import * as React from "react";
import "./AvatarDisplay.component.css";
import { useAvatarConfigStore } from "../../store/avatar-config.store";
import { LegacyAvatarPreview } from "./legacy-avatar-preview/LegacyAvatarPreview.component";
import { AvatarStyle } from "flavr-common";
import { useTranslation } from "react-i18next";
export function AvatarDisplay(_a) {
    var _b, _c, _d;
    var { username = (_b = localStorage.getItem("username")) !== null && _b !== void 0 ? _b : "Guest" } = _a;
    const avatarDefinition = useAvatarConfigStore((state) => state.avatar);
    const { t } = useTranslation();
    return (React.createElement("div", { className: "avatar-display-container", "data-tooltip": t("common:avatar-display-tooltip", "This is a preview of how other users will see you in the 3D world") },
        React.createElement(LegacyAvatarPreview, { username: username, avatarBaseColor: avatarDefinition.baseColor, avatarHatGroup: (_c = avatarDefinition.avatarHat) !== null && _c !== void 0 ? _c : { id: -1, color: 0 }, avatarShoulderGroup: (_d = avatarDefinition.avatarShoulder) !== null && _d !== void 0 ? _d : { id: -1, color: 0 }, isShowingVRStyle: avatarDefinition.style === AvatarStyle.Head })));
}
